"use strict";

module.exports = parseInt(window.document.getElementById('current-user-data').getAttribute('data-id'));